// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1oUOb","signatureBlock":"Footer_signatureBlock__1rqmf","signature":"Footer_signature__3Cucq"};